<template>
  <div id="slider-banner">
    <div v-if="isLoading" class="shimmer-placeholder">
      <div class="shimmer-carousel"></div>
    </div>
    <div v-else id="carousel-area" class="slider-back">
      <div
          id="carousel-slider"
          class="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="7000"
      >
        <div class="carousel-inner">
          <div
              v-for="(image, index) in filteredImages"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
              :data-interval="index === 0 ? 7000 : 5000"
          >
<!--            <router-link :to="`/${image.link}`" :aria-label="image.alt" @click="logLink(image.link)">-->
<!--              <img-->
<!--                  class="d-block w-100"-->
<!--                  :src="image.src"-->
<!--                  :alt="image.alt"-->
<!--                  :loading="index === 0 ? 'eager' : 'lazy'"-->
<!--              />-->
<!--            </router-link>-->
            <a href="#" @click.prevent="logLink(image.link)">
              <img
                  class="d-block w-100"
                  :src="image.src"
                  :alt="image.alt"
                  decoding="async"
                  :loading="index === 0 ? 'eager' : 'lazy'"
                  @error="setFallbackImage($event)"
              />
            </a>
          </div>
        </div>
        <a
            class="carousel-control-prev"
            href="#carousel-slider"
            role="button"
            data-bs-slide="prev"
            aria-label="Previous"
            @click="handleManualNavigation"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        </a>
        <a
            class="carousel-control-next"
            href="#carousel-slider"
            role="button"
            data-bs-slide="next"
            aria-label="Next"
            @click="handleManualNavigation"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
        </a>
        <!-- Loader Bar -->
        <div class="loader-bar">
          <div ref="loader" class="loader-progress"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useSliderStore } from '@/stores/slider';
import router from '@/router/index.js'

const route = useRoute();
const authStore = useAuthStore();
const sliderStore = useSliderStore();
const loader = ref(null);
const isLoading = ref(true);

const filteredImages = computed(() => {
  if (isLoading.value || !sliderStore.images.length) {
    return [
      {
        src: 'https://storage.googleapis.com/maybet/promotion/carousel_1740984334727187328.png',
        alt: 'Bethub Default Image',
        link: '/bethub',
      },

    ];
  }
  const filterFn = sliderStore.routeFilters[route.name] || (() => false);
  let images = sliderStore.images.filter(filterFn);

  if (images.length === 0) {
    images = [
      {
        src: 'https://storage.googleapis.com/maybet/promotion/carousel_1740984334727187328.png',
        alt: 'Bethub Default Image',
        link: '/bethub',
      },
    ];
  }
  if (authStore.user?.auth) {
    images = images.filter((img) => img.link !== '/freebet');
  }
  return images;
});

function setFallbackImage(event) {
  // console.log('Fallback image', event);
  if (authStore.user?.auth) {
    event.target.src = '/assets/images/backup/bethub.png';
    event.target.alt = 'BetHub';
    event.target.link = '/bethub';
  } else {
    event.target.src = '/assets/images/backup/freebet.webp';
    event.target.alt = 'Freebet';
    event.target.link = '/freebet';
  }
}

const getInterval = () => {
  const activeItem = document.querySelector('#carousel-slider .carousel-item.active');
  return activeItem?.getAttribute('data-interval') || 5000;
};

const logLink = async (link) => {
  // console.log(link);
  if (link) {
    const formattedLink = link.startsWith("/") ? link : `/${link}`;
    await router.push({ path: formattedLink, force: true });
    setTimeout(() => {
      window.location.reload();
    }, 500)
  }
}

const startLoader = (duration) => {
  if (loader.value) {
    loader.value.style.transition = 'none';
    loader.value.style.width = '0%';
    setTimeout(() => {
      if (loader.value) {
        loader.value.style.transition = `width ${duration}ms linear`;
        loader.value.style.width = '100%';
      }
    }, 100);
  }
};

function handleManualNavigation(event) {
  event.stopPropagation();
  prepareLoader();
}

const prepareLoader = () => {
  const interval = getInterval();
  startLoader(interval);
};

const resetLoader = () => {
  prepareLoader();
};

onMounted(async () => {
  const carouselSlider = document.getElementById('carousel-slider');
  if (carouselSlider) {
    carouselSlider.addEventListener('slide.bs.carousel', prepareLoader);
    carouselSlider.addEventListener('slid.bs.carousel', resetLoader);
  }
  try {
    await sliderStore.fetchCarousels();
  } catch (error) {
    console.error('Error fetching carousels:', error);
  }
  isLoading.value = false;
  await nextTick();
  startLoader(7000);
});

onBeforeUnmount(() => {
  const carouselSlider = document.getElementById('carousel-slider');
  if (carouselSlider) {
    carouselSlider.removeEventListener('slide.bs.carousel', prepareLoader);
    carouselSlider.removeEventListener('slid.bs.carousel', resetLoader);
  }
});
</script>

<style scoped>
.loader-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.loader-progress {
  height: 100%;
  width: 0%;
  background-color: #ffcc00;
}

.carousel-inner img {
  object-fit: cover;
}

.shimmer-placeholder {
  position: relative;
  width: 100%;
  height: 100px;
  overflow: hidden;
  background-color: #e0e0e0;
}

.shimmer-carousel {
  width: 100%;
  height: 100%;
  background: #e0e0e0 linear-gradient(
    to right,
    #e0e0e0 0%,
    #f0f0f0 50%,
    #e0e0e0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s linear infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>